/**
 * Money is always integer cents, never a float (DATABASE §1).
 *
 * Adapters are where floats get in: the Albert Heijn API returns prices as
 * JSON numbers in euros (`2.19`, `priceBeforeBonus`). `2.19 * 100` is
 * 218.99999999999997 in IEEE-754, so the conversion has to round rather than
 * truncate — `Math.trunc` here would quietly shave a cent off a good fraction
 * of the catalogue.
 */
/** Convert a euro amount to integer cents. Returns null for absent or non-finite input. */
export function eurosToCents(euros) {
    if (euros === null || euros === undefined || euros === '')
        return null;
    const n = typeof euros === 'string' ? Number(euros.replace(',', '.')) : euros;
    if (!Number.isFinite(n))
        return null;
    return Math.round(n * 100);
}
/** Format integer cents the Dutch way: 249 → "€2,49". Display only. */
export function formatCents(cents) {
    if (cents === null || cents === undefined || !Number.isFinite(cents))
        return null;
    const sign = cents < 0 ? '-' : '';
    const abs = Math.abs(cents);
    return `${sign}€${Math.floor(abs / 100)},${String(abs % 100).padStart(2, '0')}`;
}
/**
 * Unit price in cents per base unit (per litre, per kg, per stuk).
 *
 * ARCHITECTURE §5.5: a 500ml carton at €1,15 is not cheaper than a litre at
 * €2,05, and only price-per-litre says so honestly. Returns null when the size
 * is unknown — the UI then shows the shelf price alone rather than a wrong
 * comparison (ADAPTERS §9.3).
 */
export function unitPriceCents(priceCents, size) {
    if (priceCents === null || priceCents === undefined)
        return null;
    if (!size || !Number.isFinite(size.value) || size.value <= 0)
        return null;
    return Math.round(priceCents / size.value);
}
//# sourceMappingURL=money.js.map